import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

const IDEM_PATHS = ["/sales", "/payments", "/income", "/expenses", "/quotes", "/transfers"];

const hash = (str) => {
  let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (h2 >>> 0).toString(16) + (h1 >>> 0).toString(16);
};

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const path = (config.url || "").split("?")[0];
  if (config.method === "post" && IDEM_PATHS.includes(path) && config.data && !(config.data instanceof FormData)) {
    config.headers["Idempotency-Key"] = hash(path + JSON.stringify(config.data));
  }
  return config;
});

let lastNetToast = 0;
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    } else if (!e.response) {
      if (Date.now() - lastNetToast > 2000) {
        lastNetToast = Date.now();
        toast.error("Bağlantı kurulamadı. İşleminiz henüz kaydedilmedi.", { description: "İnternet veya sunucu bağlantısını kontrol edip tekrar deneyin." });
      }
    } else if (e.response.status >= 500) {
      toast.error("Veri kaydedilemedi (sunucu hatası).", { description: "İşleminiz kaydedilmedi, lütfen tekrar deneyin." });
    }
    return Promise.reject(e);
  }
);
